
import ExampleAuthen from '~/pages/_lang/example-authen'
export default ExampleAuthen
